import axios from "axios";
import { authHeader } from "../utils/authHeader";

const apiUrl = process.env.REACT_APP_API_URL;

export const AdsSubscriptionsByDateRange = (startDate, endDate, accessToken) => {
  return axios.get(
    apiUrl + "/report/subscriptions/ads/" + startDate + "/" + endDate,
    {
      headers: authHeader(accessToken),
    }
  );
};

export const AdsSubscriptionsByDate = (date, accessToken) => {
  return axios.get(apiUrl + "/report/subscriptions/ads/day/" + date, {
    headers: authHeader(accessToken),
  });
};
